import { Component, forwardRef, OnInit, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-colorpicker',
  templateUrl: './d-colorpicker.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DColorpickerComponent),
      multi: true
    }
  ]
})
export class DColorpickerComponent extends DynamicComponentBase {
  static KEY = 'd-colorpicker';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    if (!config.value) {
      config.value = '#000';
    }
  }
}
